<template>
	<div>
		<div :class="{'background-green' : active}" class="list-border mt-3">
			<div class="padding-16">
				<img class="who-text-margin" width="24" height="24" src="../../../../assets/images/icons/solid/automation_when.svg"/>
				<label :class="{'automation-group-title-color' : active}" class="automation-group-title ml-3 ">
					WHEN <section class="display-inline-block font-weight-500">(Event)</section>
				</label>
				
				<div v-if="active || selection_when != ''" class="padding-8-top">
						<div class="padding-16 condition-border">
							<div class="font-16 font-gilroy font-weight-500 flex space-around">
								<section class="option_section">
									<v-select class="fit-content" @input="selectWhenChanged($event)" :placeholder="'Pick Option'" :searchable="true" track-by="value"  v-model="selection_when" single label="name" :options="automation_event_options" v-validate="'required'" name="when_"></v-select>
									<span v-if="errors.first('when_')" class="input-error-msg mr-3">This field is required</span>
								</section>

								<section v-if="completed_program_chosen" class="option_section ml-3">
									<v-select class="fit-content" :placeholder="'Pick Option'" :searchable="true" track-by="value"  v-model="selection_when.program" single label="name" @input="assignProgramID($event)" :options="completed_program_chosen" v-validate="'required'" name="program_when"></v-select>
									<span v-if="errors.first('program_when')" class="input-error-msg mr-3">Program field is required</span>
								</section>
							</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import automationMixin from '../../automationMixin'
export default {
	props:{
		active:{
			active:{
				type: Boolean
			}
		},
		automation_edit_detail:{
			required: false
		},
		edit_view:{
			required: true
		}
	},
	mixins: [automationMixin],
	data : function(){
		return{
			selection_when:'',
			automation_event_options:[],
			when_filters:{}
		}
	},
	computed : {
		completed_program_chosen(){
			if((this.selection_when != '' || this.selection_when != null ) && this.selection_when.inputs && this.selection_when.inputs[0].data){
				document.querySelector(".main-section").style['overflow-y'] = "auto";
				return this.selection_when.inputs[0].data
			}else{
				document.querySelector(".main-section").style['overflow-y'] = "hidden";
				return false
			}
		},
		get_current_event(){
			return this.$store.getters.getEvents
		}
	

	},
	beforeDestroy(){
		 this.$nextTick(() => {
			document.querySelector(".main-section").style['overflow-y'] = "hidden";
			this.cleanMemory()
		})
	},
	watch:{
		get_current_event(val){
			if(val && val != {}){
				this.updateData()
			}
		},
		edit_view(val){
			if(val){
				this.$store.commit('setCurrentEvent', this.automation_edit_detail)
				this.updateData()

			}else{
				this.selection_when = ''
			}
		},
	},
	created : function(){
		this.getEvents()
	},
	methods : {
		selectWhenChanged(event){
			if(event && event.id == 3){
				this.selection_when.program = null
				this.$emit('updateWHENcondition', false)
				this.getCompleteWhenAPIFilters()
			}else{
				if(!event){
					this.$emit('updateWHENcondition', false)
				}else{
					this.$validator.validateAll('when_').then((result) => {
						this.$emit('updateWHENcondition', result)
						this.getCompleteWhenAPIFilters()
					});
				}
			}
		},
		updateData(){
			this.automation_event_options.forEach(elem =>{
				if(elem.id == this.automation_edit_detail[0].id){
					this.selection_when = elem
					if(this.selection_when.inputs && this.automation_edit_detail[0].value){
						this.selection_when.inputs[0].data.forEach(elem =>{
							if(elem.id == this.automation_edit_detail[0].value[0].value){
								this.selection_when.program = elem
							}
						})
					}
				}
			})
		},
		getEvents(){
			var params = {
				filters:{
					organization_id : this.id
				}
			}
			this.$store.dispatch('getAutomationRules_When', params).then((res) => {
				this.automation_event_options = res.data.data
				if(this.edit_view){
					this.updateData()
				}
			}).catch((error) => {
				console.log(error);
			});
		},
		getCompleteWhenAPIFilters(){
			this.when_filters = {}
			this.when_filters.id = this.selection_when.id
			this.when_filters.value = null
			this.$emit('updateWhenAPI', this.when_filters)
			return this.when_filter
		},
		assignProgramID(program){
			this.$validator.validateAll(['program_when', 'when_']).then((result) => {
				this.$emit('updateWHENcondition', result)
			});
			if(program){
				this.when_filters.id = this.selection_when.id
				this.when_filters.value = [
					{
						'rule_property_id':  this.selection_when.inputs[0].id,
						'value': this.selection_when.program.id
					}
				]
				this.$emit('updateWhenAPI', this.when_filters)

			}
		},
		cleanMemory(){
			this.$store.commit('setCurrentEvent', {})
			this.selection_when = ''
		}
	}
}
</script>
<style src="../../automation.css">

</style>


// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHEN/automationWhen.vue